import setCurrentPage from "src/Utils/setCurrentPage";
import Image from "src/Components/Common/Image";

export const DATA_TO_DEMO_1 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `Introducing Rick, the manager of a region \nin the expansive realm of Fields \nOperations. Today, we're excited to unveil \nhow Infosys Turf Optimization becomes \nhis digital ally, <span style="color: #BEE3FF;">transforming the \ncomplexity of turf zoning into a \nseamlessly orchestrated symphony.</span>`,
  subtitle: "turf optimization DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(406),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(405),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_4.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "468px",
            zIndex: 1,
          }}
          imagePath="TURF_OPTIMIZATION/TO_Demo_1_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-154px",
          }}
          imagePath="characters/character_to_1.gif"
        />
      </div>
    </div>
  ),
};
